import siteData from './site_data_util';
import baseSeoUtil from './base_seo_util';

export default function(state = {}, action = {}) {
  const site = state?.config?.site;
  const siteConf = siteData || {};
  const { video } = action?.eventsPage || {};
  const view = action?.view;

  // Base data for all events pages.
  let baseData = {
    site,
    siteConf
  };

  /**
   * Looks up the type of an event based on page type.
   */
  const typeLookup = {
    calendar() {
      return Object.assign({}, baseData, {
        title: 'Fast Company Events',
        overrideTitle: true,
        url: 'https://www.fastcompany.com/events',
        description:
          'Innovation, Disruption, and the Future of Business & Technology',
        excerpt:
          'Innovation, Disruption, and the Future of Business & Technology',
        type: 'website'
      });
    },
    discover() {
      return Object.assign({}, baseData, {
        title: 'Fast Company Videos',
        overrideTitle: true,
        url: 'https://www.fastcompany.com/events/video',
        description:
          'Innovation, Disruption, and the Future of Business & Technology',
        excerpt:
          'Innovation, Disruption, and the Future of Business & Technology',
        type: 'website'
      });
    },
    video() {
      const videoId = video?.id;
      const pageTitle = video?.title;
      const videoSlug = video?.slug;
      const description = video?.description;
      const image = video?.thumbnailUrl;
      const url = `https://www.fastcompany.com/events/video/${videoSlug}/${videoId}`;
      return Object.assign({}, baseData, {
        title: pageTitle || '',
        titleSEO: pageTitle || '',
        url: url || '',
        description: description || '',
        excerpt: description || '',
        image
      });
    }
  };

  // If we have a page view, use it to override the base data.
  if (typeLookup[view]) {
    baseData = typeLookup[view]();
  }

  return baseSeoUtil(baseData);
}
